import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

import { ref } from 'vue';
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = {
  class: "dialog-footer"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'Error',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var data = ref();
    var dialogVisible = ref(false);
    var open = function open(showData) {
      data.value = showData;
      dialogVisible.value = true;
    };
    var close = function close() {
      dialogVisible.value = false;
    };
    __expose({
      open: open
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        ref: "dialog",
        title: "详情",
        width: "65%",
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(dialogVisible) ? dialogVisible.value = $event : null;
        }),
        onClose: close
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
            onClick: close
          }, {
            default: _withCtx(function () {
              return _cache[1] || (_cache[1] = [_createTextVNode("关闭")]);
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          var _unref2;
          return [_cache[2] || (_cache[2] = _createElementVNode("p", null, "异常日志", -1)), _createElementVNode("p", {
            innerHTML: (_unref2 = _unref(data)) === null || _unref2 === void 0 ? void 0 : _unref2.replace(/\r\n/g, '<br/>')
          }, null, 8, _hoisted_1)];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});